const Datastore = require('nedb')

// class Doctors {
//     db = new Datastore({ filename: "./doctors.db", autoload: true });

//     find = (criteria, callback) => {
//         this.db.find(criteria, callback);
//     }

//     findOne = (criteria, callback) => {
//         this.db.findOne(criteria, callback);
//     }

//     insert = (doctor, callback) => {
//         this.db.insert(doctor, callback);
//     }

//     update = (criteria, newDoctor, callback) => {
//         this.db.update(criteria, newDoctor, callback)
//     }
// }

let doctors = new Datastore({ filename: "./doctors.db", autoload: true });

export default doctors;


// WEBPACK FOOTER //
// ./src/services/doctors/index.js